
export enum ELicenseType{
  Unknown = 0,
  Temporary = 1,
  Trial = 2,
  Instrument = 3,
  PlateStorage = 4,
  Site = 5,
  Hybrid = 6,
  Concurrent = 7,
  Seat = 8
}

export enum ELicenseStatus{
  NoLicense = 0,
  Active = 1,
  Expired = 2
}

export enum ELicenseError{
  None = 0,
  NotActivated = 1,
  NotAuthentic = 2,
  Other = 3,
  Expired = 4,
  InvalidDevice = 5
}

export interface LicenseInfoStatus{
  licenseType : ELicenseType,
  licenseStatus: ELicenseStatus,
  licenseError: ELicenseError,
}

export interface LicenseInfo{
  clientId: string;
  clientName: string;
  clientContact: string; 
  productName: string;
  modifiedDate: string
  expiredDate: string;
  status: LicenseInfoStatus;
  isAllowToRun: boolean;
  storageCapacity: number;
}

export interface LicenseRequest{
  licenseRequestString: string;
}
